export default "__VITE_ASSET__D92vqi0i__"